<template>
    <b-modal :title="user ? 'Favoriten von ' + user.firstName + ' ' + user.lastName : null" :id="id" size="lg">
        <b-row v-bind:class="[{ busy: busy}, 'opacity-transition']">
            <pb-spinner v-if="busy"></pb-spinner>
            <b-col class="border-right">
                <h6>Artikeluche</h6>
                <b-row>
                    <b-col>
                        <b-form v-on:submit.prevent="search" class="my-2" ref="qrSearch">
                            <b-input-group>
                                <b-form-input id="search"
                                              name="search"
                                              placeholder="suche"
                                              v-model="searchTerm"
                                              class="secondary search-input"/>
                                <b-input-group-append>
                                    <b-button size="sm" @click="search()" variant="outline-primary">Suchen</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form>
                    </b-col>
                </b-row>
                <hr/>
                <b-row>
                    <b-col>
                        <div v-if="searchResult && searchResult.length > 0">
                            <b-row style="background-color: #F1F1F1" class="m-2" :key="key"
                                   v-for="(item,key) in searchResult">
                                <b-col>
                                    <article-preview
                                        class="p-0"
                                        :article-details="item"
                                        :thumbnail="item.webImage || item.image">
                                    </article-preview>
                                </b-col>
                                <b-col md="auto" align-self="center">
                                    <b-button size="sm" @click="addFavorite(item)"><i class="fal fa-plus"/> Hinzufügen
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else-if="errorMsg" class="text-left p-2">
                            {{ errorMsg }}
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <h6>Favoriten</h6>
                <b-row style="background-color: #F1F1F1" class="m-2" :key="favorite.id"
                       v-for="(favorite) in userFavorites">
                    <b-col>
                        <article-preview
                            :thumbnail="favorite.articleVariant ? favorite.articleVariant.thumbnail : favorite.articleDetails.webImage"
                            :article-details="favorite.articleDetails"/>
                    </b-col>
                    <b-col md="auto" align-self="center">
                        <b-button size="sm" @click="removeFavorite(favorite.articleId)"><i class="fal fa-trash"/>
                            Entfernen
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
import {HTTP} from "@shared/_helpers/http";
import ArticlePreview from "@client/src/components/dropdown-nav/ArticlePreview";

export default {
    name: "EditModalFavorites",
    components: {
        'article-preview': ArticlePreview
    },
    props: {
        user: Object,
        id: String
    },
    methods: {
        removeFavorite(articleId) {
            this.busy = true;
            HTTP.delete(`/users/${this.user.id}/favorite/${articleId}`)
                .then(() => {
                    return this.loadFavorites(this.user.id);
                }).finally(() => {
                this.busy = false;
            });
        },
        addFavorite(article) {
            this.busy = true;
            HTTP.post(`/users/${this.user.id}/favorite`, {
                "articleId": article.id
            }).then(() => {
                return this.loadFavorites(this.user.id);
            }).finally(() => {
                this.busy = false;
            });
        },
        loadFavorites(userId) {
            this.busy = true;
            return HTTP.get(`/users/${userId}/favorite`)
                .then(response => {
                    this.userFavorites = response.data;
                }).finally(() => {
                    this.busy = false;
                });
        },
        search() {
            this.searchResult = [];
            this.errorMsg = null;
            if (this.searchTerm && this.searchTerm.length > 2) {
                this.busy = true;
                this.errorMsg = null;

                HTTP.get(`/users/${this.user.id}/article/search/${this.searchTerm}`).then(res => {
                    if (!res || res.length === 0) {
                        this.errorMsg = "No matches."
                    } else {
                        this.searchResult = this.$_.orderBy(res.data, ['webImage', 'primaryDescription'], ['asc', 'asc']);
                    }

                }).finally(() => {
                    this.busy = false;
                });
            }
        },
    },
    data() {
        return {
            localUser: null,
            userFavorites: [],
            searchTerm: null,
            searchResult: [],
            busy: false,
            errorMsg: null
        }
    },
    watch: {
        user: {
            handler: function (val) {
                if (val) {
                    this.loadFavorites(val.id);
                    this.searchTerm = null;
                    this.searchResult = null;
                    this.errorMsg = null;
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
